
/**
 * params required
 * idperson
 */
import { defineComponent, onMounted, ref, inject, watch } from 'vue'

//components
import btnDownload from "@/components/buttons/btnDownload.vue"

//service
import FileService from '@/core/services/FileService';
import personService from "@/core/services/PersonService"
import { errManager, showMessage, mbtoa, showNotification } from "@/core/config/Tools";

import { useI18n } from "vue-i18n/index";
import GlobalService from '@/core/services/GlobalService';
export default defineComponent({
    props:{
        idperson: {
            type: String,
            required: true,
            default: ""
        },
        idacrd: {
            type: String,
            required: false,
            default: ""
        }
    },
    components:{
        btnDownload
    },
    setup(props) {
        const { t } = useI18n();
        const loader = ref(false)
        const urlServerFile = ref(process.env.VUE_APP_SERVER_FILE);
        const photo = ref( < any > {});
        const photoList = ref<any>([])
        //variables globales de foto
        const action = inject<any>('action')
        const gblPhoto = inject<any>('gblPhoto')
        const dialogPhoto = inject<any>('dialogPhoto')
        const gblDataPhoto = inject<any>('gblDataPhoto')

        //events
        const getPhoto = async () => {
            loader.value = true;
            photo.value = {};
            photoList.value.length = 0;
            await personService
                .getPhoto({
                    idperson: props.idperson, all: true
                })
                .then((res) => {
                    photoList.value = res.data;
                    if(photoList.value.length > 0) {Object.assign(photo.value, photoList.value[0])}
                    loader.value = false;
                })
                .catch(({ response}) => {
                    loader.value = false;
                    errManager(response, null, 2)
                });
        };

        const handleCurrentChange = (val: object  | undefined) => {
            Object.assign(photo.value, val)
        }

        const onDialogPhoto = () => {
            gblDataPhoto.value = {
                target: 'photo',
                id: mbtoa(props.idperson)
            }
            dialogPhoto.value = true
        }

        const removeBg = async(idphoto:any) => {
            loader.value = true;
            await FileService.removeBg({idphoto: idphoto})
            .then((res)=>{
                console.info(res.data)
                loader.value = false;
                if(res.data?.success){
                    getPhoto();
                }
            }).catch(({response})=>{
                loader.value = false;
                errManager(response, null, 2)
            })
        };

        const setPhoto = async (idacrd: string, idphoto: string) => {
            loader.value = true;
            await GlobalService.update('acreditation/photo', idacrd, 'update', {idacreditation: idacrd, idphoto: idphoto})
            .then((res)=>{
                loader.value = false;
                showNotification(res.data);
            }).catch(({response})=>{
                loader.value = false;
                errManager(response, null, 2)
            })
        }

        watch(() => gblPhoto.value, getPhoto);

        onMounted(()=>{
            getPhoto()
        })

        return {
            t,
            action,
            urlServerFile,
            mbtoa,
            loader,
            photo,
            photoList,
            handleCurrentChange,
            dialogPhoto,
            onDialogPhoto,
            removeBg,
            setPhoto
        }

    },
})
